// extracted by mini-css-extract-plugin
export default {"addEditModal":"addEditModal__Fr3LXa","saveButton":"saveButton__dv4GaM"};